/* eslint-disable better-mutation/no-mutation */

import { createReducer } from '@reduxjs/toolkit';
import { getSelectedShippingProducts } from './shipping-selectors';
import { validate } from './validate';
import { v4 as uuidv4 } from 'uuid';

const getUuid = () => uuidv4();

const initialState = validate({
    validationErrors: {},
    globalValidationError: null,
    shippingByWeight: [],
    shippingRecommendations: [],
    recommendedWeight: null,
    selectedShippingOptions: [],
    shippingOptionsLoading: false,
    shippingOptionsError: false,
    offerTakeaway: false,
    offerShipping: false,
    fromCountry: null
});

const shippingContainsTakeaway = (shippingOptions) =>
    shippingOptions.some(
        (shippingOption) =>
            shippingOption.type === 'Takeaway' ||
            shippingOption.type === 'TakeawayOnly'
    );

const shippingContainsProduct = (shippingOptions) =>
    shippingOptions.some(
        (shippingOption) =>
            shippingOption.type !== 'Takeaway' &&
            shippingOption.type !== 'TakeawayOnly'
    );

export default createReducer(initialState, {
    RESET_SHIPPING_OPTIONS: (state) => {
        state.selectedShippingOptions = [];
        state.offerShipping = false;
        return validate(state);
    },
    SET_SHIPPING_OPTIONS_BY_WEIGHT: (state, action) => {
        const { productsPerWeightSpan, shippingOptions } = action.payload;

        state.offerShipping = shippingContainsProduct(shippingOptions);
        state.offerTakeaway = shippingContainsTakeaway(shippingOptions);

        //Decorate products with cost, type & productId for draft api:
        const productsDecorated = productsPerWeightSpan.map((weightClass) => {
            const productsWithDecoration = weightClass.products.map(
                (product) => ({
                    ...product,
                    cost: product.price,
                    productId: product.id,
                    type: product.providerId,
                    uuid: getUuid()
                })
            );
            return { ...weightClass, products: productsWithDecoration };
        });

        state.shippingByWeight = productsDecorated;
        state.selectedShippingOptions = getSelectedShippingProducts(
            productsDecorated,
            shippingOptions,
            state.offerTakeaway
        );
        state.shippingOptionsLoading = false;
        state.shippingOptionsError = false;
        return validate(state);
    },

    SET_SHIPPING_OPTION_SELECTED: (state, action) => {
        const { payload } = action;

        const selectedOptions = getSelectedShippingProducts(
            state.shippingByWeight,
            payload,
            state.offerTakeaway
        );

        if (shippingContainsProduct(selectedOptions)) {
            state.offerShipping = true;
        } else {
            state.offerShipping = false;
        }

        state.selectedShippingOptions = selectedOptions;

        return validate(state);
    },
    SET_TAKEAWAY_SELECTED: (state, action) => {
        state.offerTakeaway = action.payload.offerTakeaway;
        state.selectedShippingOptions = getSelectedShippingProducts(
            state.shippingByWeight,
            state.selectedShippingOptions,
            state.offerTakeaway
        );

        return validate(state);
    },
    SET_SHIPPING_OPTIONS_ERROR: (state) => {
        state.shippingOptionsLoading = false;
        state.shippingOptionsError = true;

        return validate(state);
    },
    SET_SHIPPING_FROMCOUNTRY: (state, action) => {
        state.fromCountry = action.payload.fromCountry;
    },
    CLEAR_SHIPPING_RECOMMENDATIONS: (state) => {
        state.recommendedWeight = initialState.recommendedWeight;
        state.shippingRecommendations = initialState.shippingRecommendations;
    },
    SET_SHIPPING_RECOMMENDATIONS: (state, action) => {
        const { recommendedWeight, shippingRecommendations } = action.payload;

        state.recommendedWeight = recommendedWeight;
        state.shippingRecommendations = shippingRecommendations;
        return validate(state);
    }
});
